import React from 'react'
import AppRoutes from './layouts/navigation/AppRoutes'
import { ComponentNavigation } from './layouts/navigation/ComponentNavigation'
import { PrimeReactProvider } from 'primereact/api';

const App = () => {
   const value = {hideOverlaysOnDocumentScrolling: true,};
  return (
      <PrimeReactProvider value={value}>
        <AppRoutes componentRoutes={ComponentNavigation} />
      </PrimeReactProvider>
        
  )
}

export default App